module.exports = __webpack_public_path__ + "static/img/starflake1.71733d69.png";